<template>
  <div class="d-flex justify-content-center align-items-center vh-100 overflow-hidden">
    <b-button v-if="isRedirectBtnVisible"
              variant="primary"
              @click="router.push(defaultRoute())"
    >
      {{ t('global.back') }}
    </b-button>
    <sdui-loader v-else />
  </div>
</template>

<script setup lang="ts">
import SduiLoader from '@/components/miscellaneous/ui/common/SduiLoader.vue'
import { ref, onMounted } from 'vue'
import { useRouter} from 'vue-router'
import { useDefaultRoute } from '@/composables/utils/useDefaultRoute.ts'
import { useSduiI18n } from '@/composables/useSduiI18n.ts'

const router = useRouter()
const { defaultRoute } = useDefaultRoute()
const { t } = useSduiI18n()

const isRedirectBtnVisible = ref(false)
onMounted(() => {
  // If we are still here after 10 seconds (should not happen), offer the user a way to go back
  setTimeout(() => {
    isRedirectBtnVisible.value = true
  }, 10000)
})
</script>
